import BookingCircleIcon from "../../../assets/icons/bookingCircleImage.png";
import BookingMainImage from "../../../assets/icons/bookingName.png";
import TripCircleIcon from "../../../assets/icons/tripCircle.png";
import TripMainImage from "../../../assets/icons/tripMain.png";

export const VENDOR_STATUS = {
  ACTIVE: "active",
  COMING_SOON: "coming_soon",
};

export const RATE_ANALYSIS_VENDORS = [
  {
    id: 1,
    circleIcon: BookingCircleIcon,
    mainImage: BookingMainImage,
    value: "Booking.com",
    slug: "booking.com",
    description: "Analyze and compare rates from Booking.com",
    status: VENDOR_STATUS.COMING_SOON,
    comingSoonMessage:
      "Booking.com rate analysis is under development and will be available soon.",
  },
  {
    id: 2,
    circleIcon: TripCircleIcon,
    mainImage: TripMainImage,
    value: "Trip.com",
    slug: "trip.com",
    description: "Analyze and compare rates from Trip.com",
    status: VENDOR_STATUS.ACTIVE,
  },
];

export const getVendorFromPath = (pathname) => {
  const match = pathname.match(/\/rate-analysis\/([^/]+)/);
  if (!match) {
    return null;
  }

  const slug = decodeURIComponent(match[1]).toLowerCase();
  return RATE_ANALYSIS_VENDORS.find((vendor) => vendor.slug === slug) || null;
};

export const isVendorActive = (vendor) => vendor?.status === VENDOR_STATUS.ACTIVE;

export const isVendorComingSoon = (vendor) =>
  vendor?.status === VENDOR_STATUS.COMING_SOON;
